import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { WORKSPACE_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation CreateWorkspace(
    $name: String!
    $customerId: ID!
    $memberEmails: [String!]
    $allowAll: Boolean
    $promptIds: [ID!]!
    $templateIds: [ID!]!
    $integrations: [WorkspaceIntegrationInput!]!
    $resourceIds: [ID!]!
    $projectIds: [ID!]
    $brandVoiceIds: [ID!]!
    $defaultBrandVoiceId: ID!
    $visualLanguageIds: [ID!]
    $defaultVisualLanguageId: ID
  ) {
    createWorkspace(
      name: $name
      customerId: $customerId
      memberEmails: $memberEmails
      allowAll: $allowAll
      promptIds: $promptIds
      templateIds: $templateIds
      integrations: $integrations
      resourceIds: $resourceIds
      projectIds: $projectIds
      brandVoiceIds: $brandVoiceIds
      defaultBrandVoiceId: $defaultBrandVoiceId
      visualLanguageIds: $visualLanguageIds
      defaultVisualLanguageId: $defaultVisualLanguageId
    ) {
      ...Workspace
    }
  }
  ${WORKSPACE_FRAGMENT}
`;

export const createWorkspace = ({
  name,
  customerId,
  memberEmails,
  allowAll,
  promptIds,
  templateIds,
  integrations,
  resourceIds,
  projectIds,
  brandVoiceIds,
  defaultBrandVoiceId,
  visualLanguageIds,
  defaultVisualLanguageId,
}) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      name,
      customerId,
      memberEmails,
      allowAll,
      promptIds,
      templateIds,
      integrations,
      resourceIds,
      projectIds,
      brandVoiceIds,
      defaultBrandVoiceId,
      visualLanguageIds,
      defaultVisualLanguageId,
    },
  }).then(({ data }) => getSingleProp(data));
};
